import { render, staticRenderFns } from "./list-view.vue?vue&type=template&id=6b04a4a0"
import script from "./list-view.vue?vue&type=script&lang=ts"
export * from "./list-view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports